import React from 'react';

import { Box } from '@chakra-ui/react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const HeaderTooltip = (props) => (
  <Box display="inline-block" maxWidth="310px" border="solid 1px #595E6A" borderRadius="4px" bgColor="#595E6A" p={2}>
    <TextBodyMedium color="white">Completion/Cancellation status updates can take up to 8 hours</TextBodyMedium>
  </Box>
);
